/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-pascal-case */
import classNames from "classnames";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useOpenStore } from "../../../_store/openStore";
import { useRetireStore } from "../../../_store/retireStore";
import { useStrategyStore } from "../../../_store/strategyRetireStore";
import { useUserStore } from "../../../_store/userStore";
import api from "../../../api/api.main";
import { MTButton } from "../../../components/button/MTButton";
import LineChart2Main from "../../../components/chart/LineChart2Main";
import { FooterAfterSum } from "../../../components/FooterAfterSum/FooterAfterSum";
import { HeaderTitle } from "../../../components/header/Header";
import Container from "../../../components/layout/Container";
import NavigateGoBack from "../../../functions/Navigate.Goback";
import {
  InvestmentReturnCal,
  InvestmentReturnNormalCal,
} from "../../../functions/retirement/retirementFunction";
import {
  InvestmentReturnCalAfter,
  InvestmentReturnCalAfterNormal,
} from "../../../functions/retirement/retirementFunctionAfter";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_CARD_BG,
  STYLE_HEAD_STRAGADY,
  STYLE_MARGIN_TOP_PARENT,
  STYLE_TAB_HEADER_CLASSNAME,
  STYLE_TAB_HEDER_PROPS,
  STYLE_TAB_INACTIVE,
} from "../../../utils/useStyle";
import { calPMTFVA } from "../../education/functions/function";
import { first_reload } from "../../tax_plan/functions/firstLoad";
import {
  dataAge,
  dataAgeAF,
  loopIncome,
  loopIncomeAF,
  loopInvestmentAssets,
  loopInvestmentAssetsAF,
  loopOutcome,
  loopOutcomeAF,
  loopRemain,
  loopRemainAF,
  loopReturnInvestment,
  loopReturnInvestmentAF,
} from "../functions/functionRetriementPlan";
import ViewAfterRetirePlan_Tab from "./VIAfterRetirePlan_Tab";
import ViewBeforeRetirePlan_Tab from "./VIBeforeRetirePlan_Tab";
import StrategyMain from "./VIStrategy_Drawer";
import { useEducationStore } from "../../../_store/educationStore";

const RetireContext = createContext();
export const useRetireContext = () => useContext(RetireContext);

const ViewSummaryRetirePlan = () => {
  const retireData = useRetireStore((state) => state.retireData);
  const setRetireData = useRetireStore((state) => state.setRetireData);
  const strategy = useStrategyStore((state) => state.strategy);
  const setStrategy = useStrategyStore((state) => state.setStrategy);
  const userData = useUserStore((state) => state.userData);
  const setUserData = useUserStore((state) => state.setUserData);
  const balanceData = useBalanceStore((state) => state?.balanceData);
  const setBalanceData = useBalanceStore((state) => state?.setBalanceData);

    const educationData = useEducationStore((state) => state.educationData);
  

  const isMobile = useIsMobile();

  const [isPass, setIsPass] = useState("");
  const [tabPlan, setTabPlan] = useState(1);
  const [openStrategy, setOpenStrategy] = useState("");
  const labelhead = [
    {
      label: "ก่อนวางแผน",
      value: 1,
    },
    {
      label: "หลังวางแผน",
      value: 2,
    },
  ];
  const navigate = useNavigate();

  const [openInfo, setOpenInfo] = useState("");
  const openOutcome = useOpenStore((state) => state.openOutcome);
  const setOpenOutcome = useOpenStore((state) => state.setOpenOutcome);

  const openPassive = useOpenStore((state) => state.openPassive);
  const setOpenPasssive = useOpenStore((state) => state.setOpenPasssive);

  const openIncome = useOpenStore((state) => state.openIncome);
  const setOpenIncome = useOpenStore((state) => state.setOpenIncome);

  const openAssetGen = useOpenStore((state) => state.openAssetGen);
  const setOpenAssetGen = useOpenStore((state) => state.setOpenAssetGen);

  const openSalary = useOpenStore((state) => state.openSalary);
  const setOpenSalary = useOpenStore((state) => state.setOpenSalary);

  const openInvestment = useOpenStore((state) => state.openInvestment);
  const setOpenInvestment = useOpenStore((state) => state.setOpenInvestment);

  const openControlRate = useOpenStore((state) => state.openControlRate);
  const setOpenControlRate = useOpenStore((state) => state.setOpenControlRate);

  const openRetire = useOpenStore((state) => state.openRetire);
  const setOpenRetire = useOpenStore((state) => state.setOpenRetire);

  const openDead = useOpenStore((state) => state.openDead);
  const setOpenDead = useOpenStore((state) => state.setOpenDead);

  const [error, setError] = useState();

  const strategyLists = strategy?.map((item) => item?.key);

  useEffect(() => {
    const newRetireData = {
      ...retireData,
      is_plan: true,
    };

    if (strategyLists?.includes("strategy_income")) {
      setOpenIncome(true);
    }

    if (strategyLists?.includes("strategy_control_rate_outcome")) {
      setOpenOutcome(true);
    }

    if (strategyLists?.includes("strategy_assets_generate_per_year")) {
      setOpenAssetGen(true);
    }

    if (strategyLists?.includes("strategy_passive_income_retire")) {
      setOpenPasssive(true);
    }

    if (strategyLists?.includes("strategy_salary_peryear")) {
      setOpenSalary(true);
    }

    if (strategyLists?.includes("strategy_out_come")) {
      setOpenOutcome(true);
    }

    if (strategyLists?.includes("strategy_assets_generate")) {
      setOpenAssetGen(true);
    }

    if (strategyLists?.includes("strategy_salary")) {
      setOpenSalary(true);
    }

    if (
      strategyLists?.includes("strategy_investment_bf_retirement_change") ||
      strategyLists?.includes("strategy_investment_af_retirement_change")
    ) {
      newRetireData.strategy_investment_bf_retirement_change =
        strategy?.find(
          (item) => item?.key === "strategy_investment_bf_retirement_change"
        )?.amount || 0;

      newRetireData.strategy_investment_af_retirement_change =
        strategy?.find(
          (item) => item?.key === "strategy_investment_af_retirement_change"
        )?.amount || 0;

      setOpenInvestment(true);
    }

    if (strategyLists?.includes("strategy_control_rate_outcome")) {
      setOpenControlRate(true);
    }

    if (strategyLists?.includes("strategy_age_retire")) {
      setOpenRetire(true);
    }

    if (strategyLists?.includes("strategy_age_dead")) {
      setOpenDead(true);
    }

    setRetireData(newRetireData);
  }, []);

  useEffect(() => {
    const newRetireData = {
      ...retireData,
      is_plan: true,
      bf_plan_age: dataAge(),
      bf_plan_income: loopIncome(),
      bf_plan_outcome: loopOutcome(),
      bf_plan_remain: loopRemain(),
      bf_return_investment: loopReturnInvestment(),
      bf_investment_assets: loopInvestmentAssets(),

      af_plan_age: strategyLists?.includes("strategy_age_dead")
        ? dataAgeAF()
        : dataAge(),
      af_plan_income: loopIncomeAF(),
      af_plan_outcome: loopOutcomeAF(),
      af_plan_remain: loopRemainAF(),
      af_return_investment: strategyLists?.includes(
        "strategy_assets_generate_per_year"
      )
        ? loopReturnInvestmentAF()
        : loopReturnInvestment(),
      af_investment_assets: strategyLists?.includes(
        "strategy_assets_generate_per_year"
      )
        ? loopInvestmentAssetsAF()
        : loopInvestmentAssets(),
    };
    setRetireData(newRetireData);
  }, [
    setRetireData,
    retireData?.strategy_out_come,
    retireData?.strategy_income,
    retireData?.strategy_passive_income_retire,
    retireData?.strategy_assets_generate,
    retireData?.strategy_assets_generate_per_year,
    retireData?.strategy_salary,
    retireData?.strategy_salary_peryear,
    retireData?.strategy_control_rate_outcome,
    retireData?.strategy_age_retire,
    retireData?.strategy_age_dead,
    retireData?.strategy_investment_bf_retirement,
    retireData?.strategy_investment_af_retirement,
    strategy,
  ]);

  const dataInvest = () => {
    let sum = [];
    sum = retireData?.bf_return_investment?.map((bf_return_investment) => {
      return bf_return_investment?.invest;
    });
    return sum;
  };

  const lastResult = () => {
    if (
      !Array.isArray(getInvestSum) ||
      isNaN(getInvestSum[getInvestSum.length - 1])
    ) {
      return 0;
    } else {
      return getInvestSum[getInvestSum.length - 1];
    }
  };

  const dataPlan = () => {
    if (userData?.is_premium) {
      return InvestmentReturnCal(retireData, balanceData, strategy, educationData)?.map(
        (bf_investment_assets) => {
          return bf_investment_assets?.asset_invest;
        }
      );
    }
    return InvestmentReturnNormalCal(retireData)?.map(
      (bf_investment_assets) => {
        return bf_investment_assets?.asset_invest;
      }
    );
  };

  const dataPlanAF = () => {
    if (userData?.is_premium) {
      return InvestmentReturnCalAfter(retireData, strategy, balanceData, educationData)?.map(
        (af_investment_assets) => {
          return af_investment_assets?.asset_invest;
        }
      );
    }

    return InvestmentReturnCalAfterNormal(retireData, strategy)?.map(
      (af_investment_assets) => {
        return af_investment_assets?.asset_invest;
      }
    );
  };

  // console.log("dataPlan === dataPlanAF",dataPlan() === dataPlanAF());

  const getInvestSum = userData?.is_premium
    ? InvestmentReturnCal(retireData, balanceData, strategy, educationData)?.map(
        (bf_investment_assets, index) => {
          return {
            result: bf_investment_assets?.asset_invest,
            age: retireData?.bf_plan_age[index],
          };
        }
      )
    : InvestmentReturnNormalCal(retireData)?.map(
        (bf_investment_assets, index) => {
          return {
            result: bf_investment_assets?.asset_invest,
            age: retireData?.bf_plan_age[index],
          };
        }
      );

  const getInvestSumAF = useMemo(() => {

    return userData?.is_premium
      ? InvestmentReturnCalAfter(retireData, strategy, balanceData, educationData)?.map(
          (af_investment_assets, index) => {
            return {
              result: af_investment_assets?.asset_invest,
              age: retireData?.af_plan_age[index],
            };
          }
        )
      : InvestmentReturnCalAfterNormal(retireData, strategy)?.map(
          (af_investment_assets, index) => {
            return {
              result: af_investment_assets?.asset_invest,
              age: retireData?.af_plan_age?.[index],
            };
          }
        );
  }, [strategy, retireData, balanceData, tabPlan]);

  const straigyLists = strategy?.map((item) => item?.key);

  const lastResultBF = getInvestSum[getInvestSum?.length - 1];
  const lastResultAF = getInvestSumAF[getInvestSumAF?.length - 1];

  const retirementAge = retireData?.age_retire;
  const retirementAgeAF = straigyLists?.includes("strategy_age_retire")
    ? retireData?.strategy_age_retire
    : retireData?.age_retire;

  const retireBF = getInvestSum.find(
    (result) => result.age === retirementAge
  )?.result;

  const retireAF = getInvestSumAF.find(
    (result) => result.age === retirementAgeAF
  )?.result;

  const getremainBF = getInvestSum?.filter((thisRemain, i) => {
    if (thisRemain?.result <= 0) return { ...thisRemain };
  })?.[0];

  const remainBF = getremainBF?.age;

  const getremainAF = getInvestSumAF?.filter((thisRemain, i) => {
    if (thisRemain?.result <= 0) return { ...thisRemain };
  })?.[0];

  const remainAF = Number(getremainAF?.age);

  const checkError =
    retireData?.strategy_sum === 0 || retireData?.strategy_sum === "";

  let check = tabPlan === 2 ? lastResultAF?.result : lastResultBF?.result;

  const onClickViewSTG = () => setOpenStrategy(!openStrategy);

  const convertYearToMonth = (year) => {
    return year * 12;
  };

  const beforeDiffYear = Math.abs(
    retireData?.age_retire - retireData?.age_current
  );
  const afterDiffYear = Math.abs(
    strategyLists?.includes("strategy_age_retire")
      ? retireData?.strategy_age_retire - retireData?.age_current
      : retireData?.age_retire - retireData?.age_current
  );

  const afterDiffYearCheck = strategyLists?.includes("strategy_age_retire")
    ? retireData?.strategy_age_retire - retireData?.age_current
    : retireData?.age_retire - retireData?.age_current;

  // investment_bf_retirement ผลตอบแทนจากการลงทุนก่อนเกษียณต่อปี (%)
  const sumBeforeRetireInvest = useMemo(() => {
    const convertedMonth = convertYearToMonth(beforeDiffYear);
    const calPercent =
      retireData?.investment_bf_retirement < 0
        ? 3
        : retireData?.investment_bf_retirement;

    const sumPMT = calPMTFVA(
      Math.abs(lastResultBF?.result),
      calPercent / 100 / 12,
      convertedMonth
    );
    return sumPMT;
  }, [retireData]);

  const sumAfterRetireInvest = useMemo(() => {
    const convertedMonth = convertYearToMonth(afterDiffYear);
    const calPercent = strategyLists?.includes(
      "strategy_investment_bf_retirement_change"
    )
      ? retireData?.strategy_investment_bf_retirement_change
      : retireData?.investment_bf_retirement;

    const sumPMT = calPMTFVA(
      Math.abs(lastResultAF?.result),
      calPercent / 100 / 12,
      convertedMonth
    );

    return sumPMT;
  }, [retireData, strategy]);


  useEffect(() => {
    let ignore = false;
    first_reload(ignore);
    return () => {
      ignore = true;
    };
  }, []);

  useEffect(() => {
    sendRetireData();
  }, [retireData]);

  const sendRetireData = async () => {
    try {
      const id = userData?._id;

      await api.put(`profiles/${id}`, {
        retirement_before: lastResultBF?.result,
        retirement_after: lastResultAF?.result,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div id="first_reload">
      <Container>
        <HeaderTitle
          title="วางแผนเกษียณ"
          isGoback
          onClickGoBack={() => {
            NavigateGoBack(navigate);
          }}
        />
        <div className={`${STYLE_MARGIN_TOP_PARENT} mb-10  `}>
          <div className="px-6">
            <div className=" mb-[18px]">
              {check > 0 ? (
                <div className=" text-center text-black text-md flex flex-col gap-[9px]">
                  <img
                    src="/images/goodface.svg"
                    className="w-18 h-18 mx-auto"
                  />
                  <div>
                    <div>ยินดีด้วย...</div>
                    ท่านสามารถใช้ชีวิตหลังเกษียณได้ตามที่ท่านตั้งใจไว้
                  </div>
                </div>
              ) : (
                <div className=" text-center text-black text-md flex flex-col gap-[9px]">
                  <img
                    src="/images/badface.svg"
                    className="w-18 h-18 mx-auto"
                  />
                  <div>
                    ไม่นะ..เมื่อท่านอายุ {retireData?.age_dead} ปี
                    <div>เงินของท่านจะหมดลง ก่อนสิ้นอายุขัย</div>
                  </div>
                </div>
              )}
            </div>
            {retireData?.strategy_sum ? (
              <div className={`${STYLE_CARD_BG} mb-[18px]`}>
                <div className=" flex flex-col gap-2 mb-[8px] ">
                  <div className={STYLE_HEAD_STRAGADY}>
                    เปรียบเทียบระหว่างก่อน-หลังวางแผน
                  </div>
                  <div
                    className={`border-b border-mainyellow w-[295px] `}
                  ></div>
                </div>
                <div className="px-4">
                  <LineChart2Main
                    labels={dataAgeAF()}
                    dataPlan={dataPlan()}
                    dataPlan2={dataPlanAF()}
                    head={`ก่อนปรับกลยุทธ์`}
                    head2={`หลังปรับกลยุทธ์`}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className={`${STYLE_CARD_BG}  px-4`}>
              <div className={`${STYLE_TAB_HEADER_CLASSNAME} flex w-full `}>
                <div className={` w-full`}>
                  <div
                    onClick={() => {
                      setTabPlan(1);
                    }}
                    className={classNames(
                      tabPlan === 1
                        ? `${STYLE_TAB_HEDER_PROPS} font-semibold font-IBMPlexSansThai text-md md:text-lg  w-full text-center text-gray100 cursor-pointer `
                        : `${STYLE_TAB_INACTIVE} text-center text-gray100 flex justify-center items-center py-1 cursor-pointer `
                    )}
                  >
                    ก่อนวางแผน
                  </div>
                </div>
                <div className={` w-full`}>
                  <div
                    onClick={() => {
                      !checkError && setTabPlan(2);
                    }}
                    className={classNames(
                      tabPlan === 2
                        ? `${STYLE_TAB_HEDER_PROPS} font-semibold font-IBMPlexSansThai xxs:text-sm sm:text-md w-full text-center text-gray100 flex justify-center items-center cursor-pointer `
                        : `${STYLE_TAB_INACTIVE} text-center text-gray100 flex justify-center items-center py-1 cursor-pointer `
                    )}
                  >
                    หลังวางแผน
                  </div>
                </div>
              </div>

              <div className=" ">
                {/*-------------------- ตารางก่อนวางแผน --------------------*/}
                {tabPlan === 1 && (
                  <>
                    <ViewBeforeRetirePlan_Tab
                      onClickSTG={onClickViewSTG}
                      labelsbf={dataAge()}
                      databf={dataPlan()}
                      lastResult={lastResultBF}
                      retireResult={retireBF}
                      remain={remainBF}
                      retireData={retireData}
                      setRetireData={setRetireData}
                      strategyChange={retireData?.strategy_sum ? true : false}
                      onClick={() => {
                        setTabPlan(1);
                      }}
                      beforeDiffYear={beforeDiffYear}
                      sumBeforeRetireInvest={sumBeforeRetireInvest}
                      userData={userData}
                    />
                  </>
                )}

                {/* -------------------- ตารางหลังวางแผน -------------------- */}
                {tabPlan === 2 && (
                  <>
                    <ViewAfterRetirePlan_Tab
                      onClickSTG={onClickViewSTG}
                      dataaf={dataPlanAF()}
                      labelsaf={dataAgeAF()}
                      showPaire={retireData?.strategy_sum}
                      lastResult={lastResultAF}
                      retireResult={retireAF}
                      remain={remainAF}
                      strategyChange={retireData?.strategy_sum ? true : false}
                      strategy={strategy}
                      setStrategy={setStrategy}
                      isPass={isPass}
                      retireData={retireData}
                      setRetireData={setRetireData}
                      onClick={() => {
                        setTabPlan(2);
                      }}
                      afterDiffYear={afterDiffYear}
                      afterDiffYearCheck={afterDiffYearCheck}
                      sumAfterRetireInvest={sumAfterRetireInvest}
                      userData={userData}
                      strategyLists={strategyLists}
                    />
                  </>
                )}
              </div>

              <div className=" mt-3 mb-[6px] grid grid-cols-2 gap-[13px]  w-full">
                <MTButton
                  width="w-full"
                  onClick={() => {
                    if (tabPlan === 1) {
                      return navigate("/summarytablemovements?before");
                    }
                    return navigate("/summarytablemovements?after");
                  }}
                  text="ดูรายละเอียด"
                  color="border-maincyan bg-white"
                  colortext="text-maincyan group-hover:text-white font-medium"
                  hovercolor="hover:bg-maincyan group "
                  variant="outlined"
                />
                <MTButton
                  // loading={loading}
                  width="w-full"
                  text="ย้อนกลับ"
                  color="bg-gray60"
                  hovercolor="hover:bg-gray80"
                  onClick={() => {
                    const temp = { ...retireData };
                    // console.log("temp", temp);
                    setRetireData(temp);
                    NavigateGoBack(navigate);
                  }}
                />

                {/*---------- ทดสอบความอ่อนไหว หลังวางแผน ---------*/}
                {tabPlan === 2 && (
                  <>
                    {userData?._id ? (
                      userData?.is_premium ? (
                        <div className=" col-span-full">
                          <MTButton
                            onClick={() => navigate("/sensitivetest")}
                            text="ทดสอบความอ่อนไหว"
                            color="bg-maincyan "
                            colortext="text-white font-medium"
                            width="w-full"
                          />
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>

              {openStrategy && (
                <StrategyMain
                  setError={setError}
                  error={error}
                  strategy={strategy}
                  setStrategy={setStrategy}
                  openStrategy={openStrategy}
                  setOpenStrategy={setOpenStrategy}
                  openInfo={openInfo}
                  setOpenInfo={setOpenInfo}
                  openOutcome={openOutcome}
                  setOpenOutcome={setOpenOutcome}
                  openPassive={openPassive}
                  setOpenPasssive={setOpenPasssive}
                  openIncome={openIncome}
                  setOpenIncome={setOpenIncome}
                  openAssetGen={openAssetGen}
                  setOpenAssetGen={setOpenAssetGen}
                  openSalary={openSalary}
                  setOpenSalary={setOpenSalary}
                  openInvestment={openInvestment}
                  setOpenInvestment={setOpenInvestment}
                  openControlRate={openControlRate}
                  setOpenControlRate={setOpenControlRate}
                  openRetire={openRetire}
                  setOpenRetire={setOpenRetire}
                  openDead={openDead}
                  setOpenDead={setOpenDead}
                  setTabPlan={setTabPlan}
                  onClick={() => {
                    setIsPass(true);
                    setOpenStrategy(false);
                  }}
                />
              )}
            </div>
            <FooterAfterSum />
          </div>
        </div>
      </Container>
    </div>
  );
};
export default ViewSummaryRetirePlan;
